export default __webpack_public_path__ + "static/media/right_sidebar_low_stack.1478882f.svg";